export function fmtDate(iso, opts) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-AU", opts || { day: "numeric", month: "long", year: "numeric" });
  } catch { return iso; }
}
export function fmtTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" });
  } catch { return iso; }
}
export function fmtDateTime(iso) {
  if (!iso) return "-";
  return `${fmtDate(iso)}  ${fmtTime(iso)}`;
}

export const STATUS_META = {
  "Draft": { bg: "bg-slate-100", text: "text-slate-700", dot: "#64748B" },
  "Pending Assignment": { bg: "bg-amber-50", text: "text-amber-800", dot: "#F59E0B" },
  "Assigned": { bg: "bg-amber-50", text: "text-amber-800", dot: "#F59E0B" },
  "Accepted": { bg: "bg-indigo-50", text: "text-indigo-800", dot: "#6366F1" },
  "In Transit": { bg: "bg-blue-50", text: "text-blue-800", dot: "#2563EB" },
  "Arrived": { bg: "bg-purple-50", text: "text-purple-800", dot: "#7C3AED" },
  "Completed": { bg: "bg-emerald-50", text: "text-emerald-800", dot: "#059669" },
  "Partial Delivery": { bg: "bg-orange-50", text: "text-orange-800", dot: "#EA580C" },
  "Failed Delivery": { bg: "bg-rose-50", text: "text-rose-800", dot: "#DC2626" },
  "Cancelled": { bg: "bg-slate-100", text: "text-slate-500", dot: "#94A3B8" },
};

export function parseState(address) {
  if (!address) return "";
  const m = address.toUpperCase().match(/\b(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\b/);
  return m ? m[1] : "";
}

const STREET_TYPES = "(st|street|rd|road|ave|avenue|pl|place|dr|drive|hwy|highway|ln|lane|ct|court|cres|crescent|pde|parade|way|blvd|boulevard|tce|terrace|cl|close|gr|grove|sq|square|cct|circuit)";

export function parseSuburb(address) {
  if (!address) return "";
  let s = address.replace(/\b(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\b.*$/i, "").trim().replace(/,\s*$/, "").trim();
  let seg = s.split(",").pop().trim();
  const re = new RegExp("\\b" + STREET_TYPES + "\\b", "ig");
  let last = -1, m;
  while ((m = re.exec(seg)) !== null) last = m.index + m[0].length;
  if (last >= 0) seg = seg.slice(last).trim();
  seg = seg.replace(/^[\d/\-\s]+/, "").trim();
  return seg || s.split(",").pop().trim();
}
